import React__default from 'react';
import classnames from 'classnames';
import { Heading, Text } from '@grandvisionhq/elements';

const ConfiguratorStepTitleAndDescription = ({ title , description , titleClassName , descriptionClassName , textAlignment ='center' ,  })=>{
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-step-headings"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        component: "h2",
        variant: "medium",
        align: textAlignment,
        className: classnames('configurator-step-headings__title', titleClassName)
    }, title), description && /*#__PURE__*/ React__default.createElement(Text, {
        className: classnames('configurator-step-headings__description', descriptionClassName),
        variant: "body",
        align: textAlignment
    }, description));
};
var ConfiguratorStepTitleAndDescription$1 = ConfiguratorStepTitleAndDescription;

export { ConfiguratorStepTitleAndDescription$1 as default };
//# sourceMappingURL=ConfiguratorStepTitleAndDescription.js.map
